import React from 'react';
import I18n from 'i18n-js';
import Modal from '@reverbdotcom/commons/src/components/modal';
import BumpV2ModalContainer, { BumpV2ModalContainerProps } from './bump_v2_modal_container';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { formatBid } from './bump_helpers';
import { BumpControllerProps, bumpRecommendationsController } from './bump_controller';

const COMPONENT_NAME = 'ProductPageBump';

interface ExternalProps {
  showModal: boolean;
  hidePercentCallout?: boolean;
  buttonText?: string;
  buttonClassName?: string;
  refetch: () => void;
}

interface PercentCalloutProps {
  bid: number;
}

function PercentCallout(props: PercentCalloutProps) {
  if (!props.bid) {
    return null;
  }

  return (
    <SanitizedRender
      htmlTag="div"
      className="size-90 opacity-70 mb-1"
      html={I18n.t('discovery.bumpModalV2.bumpAmount',
        {
          tagOpen: '<b>',
          tagClose: '</b>',
          amount: `${formatBid(props.bid)}%`,
        },
      )}
    />
  );
}

export function BumpButton(props: ExternalProps & BumpV2ModalContainerProps) {
  const [showModal, setShowModal] = React.useState(props.showModal);
  React.useEffect(() => {
    setShowModal(props.showModal);
  }, [props.showModal]);

  const buttonText = props.buttonText || I18n.t(`discovery.bumpModalV2.${props.bid ? 'buttonEdit' : 'buttonBump'}`);
  const buttonClassName = props.buttonClassName || 'button button--primary';

  return (
    <div className="align-center">
      {!props.hidePercentCallout && <PercentCallout bid={props.bid} />}
      <button
        className={buttonClassName}
        onClick={() => setShowModal(true)}
        type="button"
      >
        {buttonText}
      </button>
      <Modal
        isOpen={showModal}
        headerTitle={I18n.t('discovery.bumpModalV2.modal.title')}
        onRequestClose={
          () => {
            setShowModal(false);
          }
        }
        paddedBody
        shouldCloseOnOverlayClick
        newClose
      >
        <BumpV2ModalContainer
          bid={props.bid}
          listingId={props.listingId}
          selectedBid={props.selectedBid}
          handleBidChange={props.handleBidChange}
          updateBid={props.updateBid}
          successMessage={props.successMessage}
          failMessage={props.failMessage}
          refetch={props.refetch}
          onRequestClose={
            () => {
              setShowModal(false);
            }
          }
        />
      </Modal>
    </div>
  );
}

const BumpButtonContainer = bumpRecommendationsController(BumpButton);

export default function BumpButtonWrapper(props: ExternalProps & BumpControllerProps) {
  return (
    <BumpButtonContainer
      componentName={COMPONENT_NAME}
      listingId={props.listingId}
      bid={props.bid}
      showModal={props.showModal}
      hidePercentCallout={props.hidePercentCallout}
      buttonText={props.buttonText}
      buttonClassName={props.buttonClassName}
      refetch={props.refetch}
    />
  );
}
